import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SidebarMenu from '../../components/Nav/MobileNav/Sidebar/SidebarMenu';


const MobileLayout = props => (
  <SidebarMenu {...props} />
);

const mapStateToProps = state => ({
  isLoggedIn: state.auth.loggedIn,
});

MobileLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(MobileLayout);



// WEBPACK FOOTER //
// ./src/app/Layout/MobileLayout/MobileLayout.js